module.exports = __webpack_public_path__ + "static/media/Elf2.e346ddfc.png";